module.exports = fox._r("images/press/icon-title-tsm.png", __webpack_public_path__ + "_/common/images/press/icon-title-tsm.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/icon-title-tsm.png
// module id = 375
// module chunks = 2